// COPIA da TMA#718 di CriGio @ 8e60f982: src/lib/burraco/useScala.ts
import { useEffect, useRef, useState } from 'react';

/** La scala che fa stare un palco di larghezza `larghezza` nello spazio che ha il suo contenitore. 1 se il browser non misura. */
export function useScala(larghezza: number): { ref: React.RefObject<HTMLDivElement | null>; scala: number } {
  const ref = useRef<HTMLDivElement>(null);
  const [scala, setScala] = useState(1);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const misura = () => {
      const w = el.clientWidth;
      if (w > 0) setScala(Math.min(w / larghezza, 2));
    };
    misura();
    const ro = new ResizeObserver(misura);
    ro.observe(el);
    return () => ro.disconnect();
  }, [larghezza]);
  return { ref, scala };
}
